/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "channelcontrols": {
        "nested": {
          "configuration": {
            "nested": {
              "EnablementStatus": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ENABLED": 1,
                  "DISABLED": 2,
                  "SCHEDULED": 3
                }
              },
              "ServiceFeeType": {
                "values": {
                  "NONE": 0,
                  "FLAT": 1,
                  "PERCENTAGE": 2
                }
              },
              "TargetType": {
                "values": {
                  "TARGET_TYPE_UNSPECIFIED": 0,
                  "TARGET_TYPE_ONLINE_SITE": 1,
                  "TARGET_TYPE_CASH_LOCAL": 2,
                  "TARGET_TYPE_DOORDASH": 3,
                  "TARGET_TYPE_UBEREATS": 4,
                  "TARGET_TYPE_GRUBHUB": 5
                }
              },
              "PauseSource": {
                "values": {
                  "SOURCE_UNSPECIFIED": 0,
                  "SOURCE_POS": 1,
                  "SOURCE_DASHBOARD": 2,
                  "SOURCE_SYSTEM": 3,
                  "SOURCE_CUSTOM": 4,
                  "SOURCE_API": 5
                }
              },
              "PauseStatusType": {
                "values": {
                  "STATUS_UNSPECIFIED": 0,
                  "STATUS_IN_EFFECT": 1,
                  "STATUS_INDEFINITE": 2,
                  "STATUS_ENDED": 3,
                  "STATUS_FAILED": 4,
                  "STATUS_EXPIRED": 5
                }
              },
              "LargeOrderLimitMode": {
                "values": {
                  "LIMIT_MODE_UNSPECIFIED": 0,
                  "QUANTITY": 1,
                  "SUBTOTAL": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.EnablementStatus && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ServiceFeeType && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.TargetType && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseSource && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseStatusType && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.LargeOrderLimitMode) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE EnablementStatus @ squareup/channelcontrols/configuration/enums.proto at 9:1
 */
export const EnablementStatus = $root.lookupEnum('squareup.channelcontrols.configuration.EnablementStatus').values;
/**
 * SOURCE ServiceFeeType @ squareup/channelcontrols/configuration/enums.proto at 16:1
 */
export const ServiceFeeType = $root.lookupEnum('squareup.channelcontrols.configuration.ServiceFeeType').values;
/**
 * @desc Identifies the type of target being paused or resumed.
 *
 * SOURCE TargetType @ squareup/channelcontrols/configuration/enums.proto at 25:1
 */
export const TargetType = $root.lookupEnum('squareup.channelcontrols.configuration.TargetType').values;
/**
 * @desc Identifies where the pause action was initiated from. This is NOT the sales channel being paused (e.g., Square Online), but rather the surface or system where the user or process took the action.
 *
 * SOURCE PauseSource @ squareup/channelcontrols/configuration/enums.proto at 60:1
 */
export const PauseSource = $root.lookupEnum('squareup.channelcontrols.configuration.PauseSource').values;
/**
 * @desc Represents the lifecycle status of an individual pause control.
 *
 * SOURCE PauseStatusType @ squareup/channelcontrols/configuration/enums.proto at 95:1
 */
export const PauseStatusType = $root.lookupEnum('squareup.channelcontrols.configuration.PauseStatusType').values;
/**
 * @desc Specifies which type of large order limit is actively enforced.
 *
 * SOURCE LargeOrderLimitMode @ squareup/channelcontrols/configuration/enums.proto at 130:1
 */
export const LargeOrderLimitMode = $root.lookupEnum('squareup.channelcontrols.configuration.LargeOrderLimitMode').values;